import React, { useState, useEffect } from 'react';
import { Button } from '../components/ui/button';
import { X, Cookie, Shield } from 'lucide-react';

export const ConsentBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] p-4 md:p-6 animate-slide-up">
      <div className="container mx-auto max-w-5xl">
        <div className="glass-card border-border/50 shadow-2xl p-6 md:p-8">
          <button
            onClick={handleDecline}
            className="absolute top-4 right-4 w-8 h-8 rounded-lg glass-effect flex items-center justify-center hover:bg-muted transition-colors"
            aria-label="Close banner"
          >
            <X className="w-4 h-4" />
          </button>

          <div className="flex flex-col md:flex-row gap-6 items-start md:items-center">
            <div className="flex-shrink-0">
              <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-primary to-accent flex items-center justify-center shadow-lg">
                <Cookie className="w-8 h-8 text-white" />
              </div>
            </div>

            <div className="flex-1">
              <h3 className="text-xl font-bold mb-2 flex items-center gap-2">
                <Shield className="w-5 h-5 text-primary" />
                Cookie Consent & Privacy
              </h3>
              <p className="text-muted-foreground leading-relaxed mb-4">
                We use essential cookies to ensure our website functions properly and to improve your experience. 
                Your uploaded code is stored locally in your browser and never sent to our servers. 
                By clicking "Accept", you agree to our use of cookies as described in our{' '}
                <a href="/privacy" className="text-primary hover:underline font-medium">
                  Privacy Policy
                </a>.
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <Button 
                  onClick={handleAccept}
                  size="lg"
                  className="shadow-lg hover:shadow-xl transition-all duration-300"
                >
                  Accept All Cookies
                </Button>
                <Button 
                  onClick={handleDecline}
                  variant="outline"
                  size="lg"
                  className="glass-effect"
                >
                  Decline Non-Essential
                </Button>
                <Button 
                  variant="ghost"
                  size="lg"
                  onClick={() => window.location.href = '/privacy'}
                >
                  Learn More
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsentBanner;